import(/* webpackMode: "eager", webpackExports: ["SubmitBatch"] */ "/app/src/app/(training)/task/[name]/submit/batch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubmitOutputOnly"] */ "/app/src/app/(training)/task/[name]/submit/output-only.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/src/components/link.tsx");
